import React from 'react';

// SectionIntroDataType interface definition
interface SectionIntroDataType {
    icon: string;
    tagline: string;
    heading1: string;
}

// Interface for props
interface SectionIntroProps {
    data: SectionIntroDataType;
}

// SectionIntro component
const SectionIntro: React.FC<SectionIntroProps> = ({ data }) => {
    return (
        <div className="section-intro">
            <div className="section-intro-header">
                <h1 className="number-display white">
                    <span className="fontawesome">{data.icon}</span>
                </h1>
                <div className="tagline-heading light">{data.tagline}</div>
                <h2 className="heading-1 light">{data.heading1}</h2>
            </div>
        </div>
    );
};

export default SectionIntro;
